import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import FirebaseService from 'services/FirebaseService';
import CategoryService from 'services/CategoryService';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
    categoryData: [],
    singleCategory:[],
    
}


export const getCategory = createAsyncThunk('category/getCategory', async (params, { rejectWithValue }) => {
	
	try {
		const response = await CategoryService.getCategory(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const createCategory = createAsyncThunk('category/createCategory', async (data, { rejectWithValue }) => {
	
	try {
		const response = await CategoryService.createCategory(data)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
})

export const updateCategory = createAsyncThunk('category/updateCategory', async (data, { rejectWithValue }) => {
	
	try {
		const response = await CategoryService.updateCategory(data)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
})



export const categorySlice = createSlice({
    name: 'category',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getCategory.pending, (state) => {
            state.loading = true
            state.message = ''
        })
        .addCase(getCategory.fulfilled, (state, action) => {
            state.loading = false
            state.categoryData = action.payload
        })
        .addCase(getCategory.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(createCategory.pending, (state) => {
            state.loading = true
            state.message= ''
        })
        .addCase(createCategory.fulfilled, (state, action) => {
            state.loading = false
           // state.data.unshift(action.payload);
            state.message = "Category Added"
        })
        .addCase(createCategory.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(updateCategory.pending, (state) => {
            state.loading = true
            state.message= ''
        })
        .addCase(updateCategory.fulfilled, (state, action) => {
            state.loading = false
           // state.data.unshift(action.payload);
            state.message = "Category Updated"
        })
        .addCase(updateCategory.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
       
       
    }
});


export default categorySlice.reducer;